module.exports = __webpack_public_path__ + "img/demo3-weight-kr.e3efeb0d.png";